module.exports = __webpack_public_path__ + "static/media/logo.da9cfb94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.png
// module id = 159
// module chunks = 28